<template>
	<div class="buylist-container">	
	    <div class="card" id="buylist-list" v-if="!editingList">
			  <div class="card-body">
			  	<button class="btn btn-sm btn-primary float-end" @click="openAddNewModal()">Add New</button>
			  	<h5 class="card-title">Buylists</h5>
			  </div>
			  <ul class="list-group list-group-flush ">
	            <li class="list-group-item d-flex align-items-center" v-for="row in data" :key="row.id">
	                <div class="flex-fill">
		                {{row.name}}
		            </div>
	                <div class="buttons">
	                    <button @click="editList(row)" class="btn btn-sm btn-primary">Edit</button>
	                    <button @click="deleteRow(row, $event)" class="btn btn-sm btn-danger">Del</button>
	                </div>
	            </li>
			  </ul>
	    </div>
        <div class="modal fade" id="add-new-modal">
            <div class="modal-dialog">

                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">New Buylist</h4>
                    </div>
                    <div class="modal-body">

                        <div class="form-group">
                            <label for="name">Name</label>
                            <input class="form-control" required id="name" v-model="form.name"/>
                        </div>

                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-default" @click="closeAddNewModal()">Close</button>
                        <button type="submit" class="btn btn-primary" v-show="!editMode" @click="save(form)">Save
                        </button>
                        <button type="submit" class="btn btn-primary" v-show="editMode" @click="update(form)">Update
                        </button>
                    </div>
                </div><!-- /.modal-content -->

            </div><!-- /.modal-dialog -->
        </div><!-- /.modal -->
        <div class="modal fade" id="import-modal">
            <div class="modal-dialog">

                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">Import Lines</h4>
                    </div>
                    <div class="modal-body">

                        <div class="form-group">
                            <label for="filename">Choose File</label>
                            <input type="file" class="form-control" accept=".csv, .xls, .xlsx" required id="importFilename" />
                        </div>

                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-default" @click="closeImportModal()">Close</button>
                        <button type="submit" class="btn btn-primary" @click="importFile">Import
                        </button>
                    </div>
                </div><!-- /.modal-content -->

            </div><!-- /.modal-dialog -->
        </div><!-- /.modal -->
        
        <div class="card" id="line-editor" v-cloak v-if="editingList">
	        <div class="card-header">
		        {{buylist.name}}
		        <button class="btn btn-sm btn-primary float-end" @click="addLine">Add Line</button>
		        <button class="btn btn-sm btn-primary float-end" @click="importLines">Import Lines</button>
		        <button class="btn btn-sm btn-primary float-end export-button" @click="exportList">Export <div class="d-none spinner-border text-light spinner-border-sm" role="status">
				  <span class="visually-hidden">Exporting...</span>
				</div></button>
		        <button class="btn btn-sm btn-primary float-end" @click="closeList">Home</button>
		        
		        <div class="dropdown float-end" id="visible-columns">
				  <button class="btn btn-primary btn-sm dropdown-toggle" type="button" id="visible-columns-btn" data-bs-toggle="dropdown" aria-expanded="false">
				    {{ $q.lang.table.columns }}
				  </button>
				  <ul class="dropdown-menu" aria-labelledby="visible-columns-btn">
				    <li v-for="column in buylistColumns" v-if="column.name != 'delBtn'" :key="column.name">
			              <label class="radio-btn" :key="visibleColumns.length">
			                  <input type="checkbox" :value='column.name' v-bind:checked="column.visible" @change="setColumns">
			                  {{ column.label }}
			              </label>
			        </li>
				  </ul>
				</div>
		        <input type="search" class="form-control form-control-sm float-end search-input" v-model="searchQuery" placeholder="Search...">
	        </div>
	        <div class="card-header" v-if="job_id != false">
		    <q-linear-progress size="25px" :value="job_pct" color="blue-grey-3">
		      <div class="absolute-full flex flex-center">
		        <q-badge color="transparent" text-color="black" :label="job_message" />
		      </div>
		    </q-linear-progress>
	        </div>
	        <div class="card-body">
		        <q-table 

		        	id="line-list"
		        	class="table table-striped table-bordered table-hover"
		        	:data="buylist.lines"
		        	:columns="buylistColumns"
		        	row-key="id"
		        	virtual-scroll
		        	:virtual-scroll-item-size="116"
		        	:virtual-scroll-sticky-size-start="116"
		        	:pagination.sync="pagination"
		        	:sort-method="resortLines"
		        	:filter="searchQuery"
					:visible-columns="visibleColumns"
					binary-state-sort
					hide-bottom
				    selection="single"
				    :selected.sync="selected"
					@keydown.native="lineKey"
					ref="buyListLinesRef" v-cloak
		        >
			        <template v-slot:body="item">
						<q-tr  v-bind:id="'line-' + item.row.id">
							<q-td></q-td>
							<template v-for="column in visibleColumns" v-if="column != 'delBtn'">
							    <q-td class="image-column" v-if="buylistColumnMap[column].datatype=='image'">
							        <img v-if="item.row[column] != ''" v-lazy="item.row[column]" :alt="item.row.sku">
							        <img v-if="item.row[column] == ''" src="/img/nopic.svg" :alt="item.row.sku">
							    </q-td>
							    <q-td class="sku-column" v-if="buylistColumnMap[column].datatype=='sku'">
							        <vue-autosuggest
							        	v-model="item.row[column]" :suggestions="suggestions" :input-props="{placeholder:'Enter a SKU...', class:'form-control line-id', 'data-col':column}" 
							        	:get-suggestion-value="getSku" :ref="item.row[column]"
							        	@keyup="onInputChange" @selected="onSelected(item, $event)"  @keydown.left="cellLeft" @keydown.right="cellRight"
							        	>  
										<template slot-scope="{suggestion}">
											<div class="d-flex justify-content-start align-items-center">
											   	<div class="mr-4">
												   	<img v-if="suggestion.item.image_url" class="image" v-lazy="suggestion.item.image_url">
												   	<img v-if="!suggestion.item.image_url" class="image" src="/img/nopic.svg">
											   	</div>
											   	<div class="flex-grow-1">
											    	<span class="item-description">{{ suggestion.item.description }}</span><br>
											    	<span class="item-sku">{{ suggestion.item.sku }}</span>
											   	</div>
											   	<div class="attribute-column">
												   	<p class="attribute"><span class="attribute-label">Category:</span><span class="attribute-value">{{ suggestion.item.category }}</span></p>
												   	<p class="attribute"><span class="attribute-label">Style:</span><span class="attribute-value">{{ suggestion.item.style }}</span></p>
												   	<p class="attribute"></p>
											   	</div>
											   	<div class="attribute-column">
												   	<p class="attribute"><span class="attribute-label">Material:</span><span class="attribute-value">{{ suggestion.item.material }}</span></p>
												   	<p class="attribute"><span class="attribute-label">Grade:</span><span class="attribute-value">{{ suggestion.item.grade }}</span></p>
												   	<p class="attribute"><span class="attribute-label">Size:</span><span class="attribute-value">{{ suggestion.item.size }}</span></p>
											   	</div>
											</div>
										</template>
									</vue-autosuggest>
							    </q-td>
							    <q-td v-if="buylistColumnMap[column].datatype=='string'">
							   		 <input type="text" class="form-control" :data-col='column' v-model="item.row[column]" @focus="selectText" @blur="processUpdate(item.row)"  @keydown.left="cellLeft" @keydown.right="cellRight">
							   		 <span class="invisible extender">{{item.row[column]}}</span>
							    </q-td>		
							    <q-td class="numeric" v-if="buylistColumnMap[column].datatype=='number'">
							        <input type="text" class="form-control usd-input" :data-col='column' v-model="item.row[column]" @focus="selectText" @blur="processUpdate(item.row)"  @keydown.left="cellLeft" @keydown.right="cellRight">
							    </q-td>			
							    <q-td class="numeric" v-if="buylistColumnMap[column].datatype=='usd'">
							        <input type="text" class="form-control usd-input" :data-col='column' v-model="item.row[column]" @focus="selectText" @blur="processUpdate(item.row)"  @keydown.left="cellLeft" @keydown.right="cellRight">
							    </q-td>			
							    <q-td class="numeric" v-if="buylistColumnMap[column].datatype=='yen'">
							        <input type="text" class="form-control yen-input" :data-col='column' v-model="item.row[column]" @focus="selectText" @blur="processUpdate(item.row)"  @keydown.left="cellLeft" @keydown.right="cellRight">
							    </q-td>		
							    <q-td class="numeric" v-if="buylistColumnMap[column].datatype=='euro'">
							        <input type="text" class="form-control euro-input" :data-col='column' v-model="item.row[column]" @focus="selectText" @blur="processUpdate(item.row)"  @keydown.left="cellLeft" @keydown.right="cellRight">
							    </q-td>							    					    
							</template>
						    <q-td>
							    <button class="btn btn-small x-btn-icon" @click="deleteItem(item.row.id, $event, item.rowIndex)"><i class='bi-trash'></i></button>
						    </q-td>
						</q-tr>			     
			        </template>
		        </q-table>
		        <div class="loading-indicator d-flex justify-content-center d-none">
					<div class="spinner-border" role="status">
						<span class="visually-hidden">Loading...</span>
					</div>
				</div>
	        </div>
        </div>
	</div>
</template>
<script>
import { Modal } from 'bootstrap';
import Vue from 'vue';
import Vuex from 'vuex';
import accounting from 'accounting';
import XLSX from 'xlsx';
import { 
  QTable,
  QTh,
  QTr,
  QTd,
  QLinearProgress
} from 'quasar';

import Quasar  from 'quasar';

import debounce from 'debounce';

import VueAutosuggest from "vue-autosuggest";
Vue.use(VueAutosuggest);

import VueLazyload from 'vue-lazyload';
Vue.use(VueLazyload, {
  preLoad: 1.3,
  attempt: 3
});




Vue.use(Vuex);
Vue.use(Quasar);

var buylistmaker =  {
    props: ['data'],
    data() {
        return {
			suggestions: [],
		    pagination: {
		        rowsPerPage: 0
		    },
			selected: [],
	        editingList: (this.getURLBuylist() !== false),
            editMode: false,
            form: {
                name: null
            },
            modal: false,
            buylist: {
	            id: false,
	            name: "Untitled",
	            lines: []
            },
            popState: false,
            lineIndex: 0,
            searchQuery: "",
            visibleColumns: [],
			buylistColumns: [],
			buylistColumnMap: {},
			toggle: 0,
			job_id: false,
			job_key: "",
			job_pct: 0,
			job_status: "",
			job_message: "",
			job_poll_interval: false
        }
    },
    components: {
	    QTable,
	    QTh,
	    QTr,
	    QTd,
	    QLinearProgress
	},
	mounted: function () {
		var self = this;
		window.onpopstate = null;
		window.addEventListener('popstate', (event) => {
			self.popState = true;
			if (event.state.buylistId) {
				self.data.forEach(function (d) {
					if (d.id == event.state.buylistId) {
						self.editList(d);
					}
				});
			} else {
				self.closeList();
			}
			self.popState = false;
		});
		
		if (this.editingList && this.buylist.id === false) {
			this.data.forEach(function (d) {
				if (d.id == self.getURLBuylist()) {
					self.editList(d);
				}
			});
		}
		
	},
    methods: {
		getSku(item) {
			return item.item.sku;
		},
		resortLines(rows, sortBy, descending) {
			// this is a dummy function.  the real sorting happens only when the pagination prop is updated - see watcher below.
			// We do this so rows do not resort while people are typing - rows only resort when users actually change the sort option
			// This more closely mirrors the excel behavior
			return rows;
		},
	    realResortLines(rows, sortBy, descending) {
		    // this is the actual resort function
		    const data = [ ...rows ], sortDirection = (descending) ? "up" : "down", sortField = sortBy, self = this;
		    	    	
		    let buylistLines = this.buylist.lines;
		    const numericSorts = ["number", "usd","yen","euro"];
	    	data.sort((a,b) => {
		    	if (a === null || a[sortField] === undefined) {
			    	a = "";
			    } else if (numericSorts.indexOf(self.buylistColumnMap[sortField].datatype) > -1) {
				    a = accounting.unformat(a[sortField]);
			    } else if (isNaN(a[sortField])) {
				    a =  a[sortField].toString().toLowerCase().trim();
				} else {
				    a =  a[sortField];
				}
		    	if (a === null) a = "";
		    	
		    	if (b === null || b[sortField] === undefined) {
			    	b = "";
			    } else if (numericSorts.indexOf(self.buylistColumnMap[sortField].datatype) > -1) {
				    b = accounting.unformat(b[sortField]);
			    } else if (isNaN(b[sortField])) {
				    b =  b[sortField].toString().toLowerCase().trim();
			    } else {
				    b =  b[sortField];
				}
		    	if (b === null) b = "";
		    	
		    	if (a > b) return ((sortDirection == "up") ? -1 : 1);
		    	if (b > a) return ((sortDirection == "up") ? 1 : -1);
		    	return 0;
	    	});
	    	
	    	return data;
		    
	    },
	    ensureAddNewModalInitialized() {
		  if (this.addNewModal === false || this.addNewModal === undefined) {
			  this.addNewModal = new Modal(document.getElementById('add-new-modal'));
		  }
	    },
	    ensureImportModalInitialized() {
		  if (this.importModal === false || this.importModal  === undefined) {
			  this.importModal  = new Modal(document.getElementById('import-modal'));
		  }
	    },
        openAddNewModal() {
	        this.ensureAddNewModalInitialized();
            this.addNewModal.show();
        },
        closeAddNewModal() {
	        this.ensureAddNewModalInitialized();
            this.addNewModal.hide();
            this.reset();
            this.editMode=false;
        },
        reset() {
            this.form = {
                name: null
            }
        },
        resetImport() {
            document.getElementById("importFilename").value = "";
        },
        async exportList() {
	        const id = this.buylist.id,  button = document.querySelector(".export-button"), spinner = document.querySelector(".export-button .spinner-border");
	        
	        try {
		        button.setAttribute("disabled", "");
		        spinner.classList.remove("d-none");
		        const response = await axios.get('/buylists/' + id + '/export');
		        
		        const info = response.data;
		        
		        if (info && info.success && info.job_id) {
			        this.job_id = info.job_id;
			        this.job_key = info.job_key;
			        this.job_status = 'Queued';
			        this.job_pct = 0;
			        this.job_message = "";
			        self = this;
			        this.job_poll_interval = setInterval(async function () {
				        const response = await axios.get('/background_jobs/' + self.job_id), button = document.querySelector(".export-button"), spinner = document.querySelector(".export-button .spinner-border");
				        
				        if (response.data.status == "Failed" || response.data.status == "Complete") {
					        self.job_status = response.data.status;
					        self.job_pct = response.data.pct_complete;
					        self.job_message = "Complete";
					        clearInterval(self.job_poll_interval);
					        if (self.job_status == "Failed") {
						        self.error(response.data.progress_message);
					        } else {
						        window.location.href = response.data.progress_message;
					        }
							button.removeAttribute("disabled");
					        spinner.classList.add("d-none");
					        self.job_id = false;
				        } else {
					        self.job_status = response.data.status;
					        self.job_pct = response.data.pct_complete / 100;
					        self.job_message = response.data.progress_message + " (" + (response.data.pct_complete).toFixed(2) + "%)";
				        }
			        }, 1000);
			        
		        }
	        } catch (e) {
		        button.removeAttribute("disabled");
		        if (spinner) spinner.classList.add("d-none");
		        
	        }
        },
        save(data) {
            this.$inertia.post('/buylists', data)
            this.reset();
            this.closeAddNewModal();
            this.editMode = false;
        },
        edit(data) {
            this.form = Object.assign({}, data);
            this.editMode = true;
            this.openAddNewModal();
        },
        importLines() {
	        this.ensureImportModalInitialized();
	        this.importModal.show();
        },
        importFile() {
	        const fileInput = document.getElementById("importFilename");
	        const self = this;
	        if (fileInput.files[0]) {
		        var reader = new FileReader();
		        reader.onload = async function (e) {
			        var data = new Uint8Array(e.target.result);
			        var workbook = XLSX.read(data, {type: 'array'});
			        const dataSet = XLSX.utils.sheet_to_json(workbook.Sheets[workbook.SheetNames[0]]);

			        var stubColumn, qtyColumn, materialColumn, descriptionColumn, styleColumn, colorColumn, sizeColumn, gradeColumn, categoryColumn, newSuggRetail, line, stubs = [];
			        
			        dataSet.forEach(row => {
					        console.log(row);
				        var topRowIsHeader = false;
					        Object.keys(row).forEach(cell => {
						        var headerName = row[cell].toString().toLowerCase().trim();
						        var cellName = cell.toString().toLowerCase().trim();
					        console.log(cellName);
					        console.log(headerName);
					        console.log('path 1');
						        if (headerName == "stub" || headerName == "sku" || cellName == "stub" || cellName == "sku" || headerName.indexOf("stub") > -1 || headerName.indexOf("sku") > -1 ||  cellName.indexOf("stub") > -1 || cellName.indexOf("sku") > -1) {
							        stubColumn = cell;
									if (headerName == cellName) topRowIsHeader = true;
						        }
						        if (headerName == "total" || headerName == "qty" || cellName == "total" || cellName == "qty"|| cellName.indexOf("qty") > -1) {
							        qtyColumn = cell;
						        }
						        if (headerName.indexOf("description") > -1 || cellName.indexOf("description") > -1) {
							        descriptionColumn = cell;
						        }
						        if (headerName.toLowerCase().indexOf("new sugg retail") > -1 || cellName.toLowerCase().indexOf("new sugg retail") > -1) {
							        newSuggRetail = cell;
						        }
						        if (headerName.indexOf("material") > -1 || cellName.indexOf("material") > -1) {
							        materialColumn = cell;
						        }
						        if (headerName.indexOf("style") > -1 || cellName.indexOf("style") > -1){
							        styleColumn = cell;
						        }
						        if (headerName.indexOf("color") > -1 || cellName.indexOf("color") > -1) {
							        colorColumn = cell;
						        }
						        if (headerName.indexOf("size") > -1 || cellName.indexOf("size") > -1) {
							        sizeColumn = cell;
						        }
						        if (headerName.indexOf("grade") > -1 || cellName.indexOf("grade") > -1) {
							        gradeColumn = cell;
						        }
						        if (headerName.indexOf("category") > -1 || cellName.indexOf("category") > -1) {
							        categoryColumn = cell;
						        }
					        });
				        if ((stubColumn !== undefined || styleColumn != undefined) && !topRowIsHeader) {
					        console.log('path 2');
					        line = {};
					        
					        if (qtyColumn) line.qty_to_buy = Math.round(row[qtyColumn]);
					        if (descriptionColumn) line.description = row[descriptionColumn];
					        if (stubColumn) line.sku = row[stubColumn];
					        if (materialColumn) line.material = row[materialColumn];
					        if (styleColumn) line.style = row[styleColumn];
					        if (colorColumn) line.color = row[colorColumn];
					        if (sizeColumn) line.size = row[sizeColumn];
					        if (newSuggRetail) line.new_sugg_retail = row[newSuggRetail];
					        if (gradeColumn) line.grade = row[gradeColumn];
					        if (categoryColumn) line.category = row[categoryColumn];
					        stubs.push(line);
				        }
			        });	        
			        const response = await axios.post('/buylists/' + self.buylist.id + '/import', JSON.stringify(stubs));
			        
			        self.populateBuylist(self.buylist.id);
					self.closeImportModal();
		        }
		        reader.readAsArrayBuffer(fileInput.files[0]);
	        }
	        
        },
        closeImportModal() {
	        this.ensureImportModalInitialized();
            this.importModal.hide();
            this.resetImport();
        },
        addLine() {
	      this.buylist.lines.push({
		      'sku': '',
		      'brand': '',
		      'image_url': '',
		      'description': '',
		      'material': '',
		      'style': '',
		      'size': '',
		      'grade': '',
		      'category': '',
		      'qty_to_buy': '',
		      'max_cost': '',
		      'max_tax_out': '',
		      'max_tax_in': '',
		      'id': false
	      });
	      this.$nextTick(() => {
		      this.$refs.buyListLinesRef.scrollTo(this.buylist.lines.length - 1);
		      setTimeout(function () { document.querySelector("#line-list table > tbody > tr:last-child input.line-id").focus(); }, 200); // nextTick don't cut it here, for whatever reason
	      });
	      this.saveItem(this.buylist.lines[this.buylist.lines.length - 1]);
        },
        updateLine(d) {
	       Object.keys(d).forEach(key => {
		       if(key == "lineIndex") return;
		       this.buylist.lines[d.index][key] = d[key];
	       });
        },
        editList(data) {
            this.buylist = { name: data.name, lines: [], id: data.id };
            this.editingList = true;
            
            const self = this;
            
			this.$nextTick(() => {
				self.populateBuylist(this.buylist.id);
			});
            
            if (!this.popState) history.pushState({
	            editingList: true,
	            buylistId: data.id
            }, null, '/buylists/view/' + data.id);
        },
        closeList() {
            this.editingList = false;
            this.buylist =  {
	            id: false,
	            name: "Untitled",
	            lines: []
            };
            if (!this.popState) history.pushState({
	            editingList: false,
	            buylistId: false
            }, null, '/buylists');
        },
        getURLBuylist() {
	       	const url = window.location.href;
	       	
	       	if (url.indexOf("buylists/view") > -1) {
		        return parseInt(url.replace(/\/$/, '').split("/").pop());
	       	} else {
		       	return false;
	       	}
        },
        update(data) {
            data._method = 'PUT';
            this.$inertia.post('/buylists/' + data.id, data)
            this.reset();
            this.closeAddNewModal();
        },
        async deleteRow(data, e) {
            await axios.delete('/buylists/' + data.id);
            this.reset();
            this.closeAddNewModal();
            document.querySelector("#buylist-list > ul").removeChild(e.target.parentNode.parentNode);
        },
        async populateColumns(buylist_id) {
	          
	        if (buylist_id !== false) {
	        	var response = await axios.get('/buylists/' + this.buylist.id + "/buylistcolumns");
		        var visibleColumns = [], map = {};
	        	response.data.forEach(function (l) {
					if (l['visible'] > 0) {
						visibleColumns.push(l['name']);
					}
					map[l['name']] = l;
			    });
			    response.data.push({
                   name: 'delBtn',
                   label: '',
				   align: 'center',
				   datatype: 'nothing'
                });
	        	this.buylistColumns = response.data;
	        	this.visibleColumns = visibleColumns;
	        	this.buylistColumnMap = map;
	        } else {
		        this.buylistColumns = [];
		        this.visibleColumns = [];
	        	this.buylistColumnMap = {};
	        }
	        
        },
        async populateBuylist(buylist_id) {
	        if (document.querySelector(".loading-indicator")) document.querySelector(".loading-indicator").classList.remove("d-none");
	        if (buylist_id !== false) {
	        	var response = await axios.get('/buylists/' + this.buylist.id + "/buylistlines"), self = this;
				await self.populateColumns(buylist_id);
	        	response.data.forEach((l) => {
					l = self.formatNumeric(l);
			
			    });
			    
	        	this.buylist.lines = response.data;
	        } else {
		        this.buylist.lines = [];
	        }
            this.visibleColumns.push('delBtn');
	        if (document.querySelector(".loading-indicator")) document.querySelector(".loading-indicator").classList.add("d-none");
        },
		selectText(e) {
			e.target.setSelectionRange(0, e.target.value.length);
		},

	    onSelected(item,suggestion) {
		    Object.assign(item.row, suggestion.item);
			item.row = this.formatNumeric(item.row);
		    this.processUpdate(item.row);
	    },	 
	    formatNumeric(row, remove) {
		    if (!row) return;
		    this.buylistColumns.forEach(col => {
			   if (row[col.name] == undefined) return;
			   if (['usd','yen','euro'].indexOf(col.datatype) == -1) return;
			   if (remove) {
				  row[col.name] = accounting.unformat(row[col.name]);
				  return;
			   }
			   if (col.datatype == "usd") {
				   row[col.name] = accounting.formatMoney(row[col.name]);
			   }
			   if (col.datatype == "yen") {
				   row[col.name] = accounting.formatMoney(row[col.name], "¥", 2);
			   }
			   if (col.datatype == "euro") {
				   row[col.name] = accounting.formatMoney(row[col.name], "€", 2);
			   }
		    });
		    return row;
	    },
        async updateItem(data) {
	        
	        document.querySelectorAll('#line-' + data.id + ' td').forEach(function (el) {
		        el.classList.add("pending");
		        el.classList.remove("success");
		        el.classList.remove("failure");
	        });
	        
			data = Object.assign({}, data);
			data = this.formatNumeric(data, true);
            data._method = 'PUT';
            if (data.index !== undefined) delete data.index;
            axios.post('/buylistlines/' + data.id, data).catch((e) => {
		        document.querySelectorAll('#line-' + data.id + ' td').forEach(function (el) {
			        el.classList.add("failure");
			        el.classList.remove("success");
			        el.classList.remove("pending");
		        });
		        
	            this.error(e);
	        }).then((e) => {
		       if (e == null) return;
		        document.querySelectorAll('#line-' + data.id + ' td').forEach(function (el) {
				    el.classList.remove("failure");
					el.classList.remove("pending");
			        el.classList.add("success");
			        setTimeout(function () {
				        el.classList.remove("success");
				        el.classList.remove("pending");
				        el.classList.remove("failure");
			        }, 2400);
		        });
	        });
        },   
        async saveItem(data) {
	        var obj = Object.assign({}, data);
	        Object.keys(obj).forEach(key => {
		       if (obj[key] == '' || obj[key] == false)  {
			       delete obj[key];
		       }
	        });
			obj = this.formatNumeric(obj, true);
	        obj.buylist_id = this.buylist.id;
            var response = await axios.post('/buylistlines', obj);
            if (response.status < 300 && response.status >= 200 && response.data && response.data.id) {
	           Object.assign(data, response.data);
	        } else {
		        this.error('Could not create line');
				this.buylist.lines.pop();
	        }
        },
        async deleteItem(id, e, index) {
            var response = await axios.delete('/buylistlines/' + id);
            
            if (response.status < 300 && response.status >= 200) {
		      // destroy the vue listeners, etc
		      var el = e.target.closest("tr"), self = this;

			  el.classList.add("removing");
			  setTimeout(function() {
				   el.classList.add("removed");
				   self.buylist.lines.splice(index, 1);
				   this.$refs.buyListLinesRef.reset();
			  }, 500);		     
	        }
        },	
	    onInputChange: debounce(async function (e) {
		   if (e.target.value == "") return false;
		   var request = axios.get('/buylists/skuautocomplete/' + e.target.value);
		   var response = await request;
		   this.suggestions = [response];
	    }, 500), 
	    setColumns () {
		    const checkedColumns = document.querySelectorAll("#visible-columns input:checked"), self = this;
		    
		    var vc = ['delBtn'], bc = [];
		    
		    checkedColumns.forEach(function (el) {
			    vc.push(el.value);
		    });
			
			this.buylistColumns.forEach((c) => {
				if (vc.indexOf(c.name) > -1) {
					bc.push(c.name);
					c.visible = true;
				} else {
					c.visible = false;	
				}
			});
			console.log(this.visibleColumns)
			console.log(bc);
		    this.visibleColumns = bc;
		    
		    
	    },
        error(string) {
	        console.log(string);
        },
        processUpdate: debounce(function (r) {
	        r = this.formatNumeric(r);
	        this.updateItem(Object.assign({}, r));
        }),
	    cellRight(e) {
		    const col = e.target.dataset.col, self = this;
		    if ( e.target.selectionStart != e.target.value.length) { return; }
		    var newCol = false, newColIndex = this.visibleColumns.indexOf(col) + 1;
		    
		    if (newColIndex >= this.visibleColumns.length - 1) return;
		    
		    newCol = this.visibleColumns[newColIndex];
		    if (this.buylistColumnMap[newCol].datatype == "image") return;
		    if (newCol) {
			    e.target.closest("tr").querySelector("input[data-col=\"" + newCol + "\"]").focus();
		    }
	    },
	    cellLeft(e) {
		    const col = e.target.dataset.col, self = this;
		    if ( e.target.selectionStart != 0) { return; }
		    
		    var newCol = false, newColIndex = this.visibleColumns.indexOf(col) - 1;
		    
		    if (newColIndex < 0) return;
		    newCol = this.visibleColumns[newColIndex];
		    
		    if (this.buylistColumnMap[newCol].datatype == "image") return;
		    
		    if (newCol) {
			    e.target.closest("tr").querySelector("input[data-col=\"" + newCol + "\"]").focus();
		    }
	    },
	    lineKey (evt) {
		    return; // this doesn't work for now
		  if ([ 33, 34, 35, 36, 38, 40 ].indexOf(evt.keyCode) === -1 ||this.$refs.buyListLinesRef === void 0) {
	        return;
	      }
      
	      evt.preventDefault();
	      const rowsNumber = this.$refs.buyListLinesRef.rowsSelectedNumber, rows = this.$refs.buyListLinesRef.computedRows;
	      console.log(this.$refs.buyListLinesRef);
	      console.log(rowsNumber);
	      console.log(rows);
	      if (rows.length === 0) {
	        return;
	      }
	      const currentIndex = this.selected.length > 0 ? rows.indexOf(this.selected[0]) : -1;
	      const currentPage = this.pagination.page;
	      const rowsPerPage = this.pagination.rowsPerPage === 0 ? rowsNumber : this.pagination.rowsPerPage;
	      const lastIndex = rows.length - 1;
	      const lastPage = Math.ceil(rowsNumber / rowsPerPage);
	      let index = currentIndex;
	      let page = currentPage;
	      switch (evt.keyCode) {
	        case 36: // Home
	          page = 1;
	          index = 0;
	          break;
	        case 35: // End
	          page = lastPage;
	          index = rowsPerPage - 1;
	          break;
	        case 33: // PageUp
	          page = currentPage <= 1 ? lastPage : currentPage - 1;
	          if (index < 0) {
	            index = 0;
	          }
	          break;
	        case 34: // PageDown
	          page = currentPage >= lastPage ? 1 : currentPage + 1;
	          if (index < 0) {
	            index = rowsPerPage - 1;
	          }
	          break;
	        case 38: // ArrowUp
	          if (currentIndex <= 0) {
	            page = currentPage <= 1 ? lastPage : currentPage - 1;
	            index = rowsPerPage - 1;
	          }
	          else {
	            index = currentIndex - 1;
	          }
	          break;
	        case 40: // ArrowDown
	          if (currentIndex >= lastIndex) {
	            page = currentPage >= lastPage ? 1 : currentPage + 1;
	            index = 0;
	          }
	          else {
	            index = currentIndex + 1;
	          }
	          break;
	      }
	      if (page !== this.pagination.page) {
	        this.pagination = {
	          ...this.pagination,
	          page
	        };
	        this.$nextTick(() => {
	          const rows  = this.$refs.buyListLinesRef.computedRows;
	          this.selected = [ rows[Math.min(index, rows.length - 1)] ];
	        });
	      }
	      else {
	        this.selected = [ rows[index] ];
	      }	    
	    }
    },
	name: 'buylistmaker',
	watch: {
		pagination: {
			handler: function (n, o) {
				console.log("pagination changes");
				this.buylist.lines = this.realResortLines(this.buylist.lines, n.sortBy, n.descending);
			},
			deep: true
		}
	},
	filters: {
		'usd': value => {
			return accounting.formatMoney(value, "$", 2);
		},
		'yen': value => {
			return accounting.formatMoney(value, "¥", 2);
		},
		'euro': value => {
			return accounting.formatMoney(value, "€", 2);
		},
		'currency': value => {
		  return accounting.formatMoney(value);
		},
		'dateFromUnixtime': date => {
		  if (parseInt(date) == date) {
			  date = new Date(date * 1000);
		  } else {
			  date = new Date(Date.parse(date));
		  }
		  if (date == "Invalid Date") return "Invalid Date";
		  return new Intl.DateTimeFormat('en-US').format(date);
		}
	}
};

export default buylistmaker;
</script>
<style>
  @import '/css/buylist.css';
</style>